import * as StringTransformer from "./string";

function transformObjectKeys(obj, getTransformedKey) {
  const transform = (mixed) => {
    if (Array.isArray(mixed)) {
      return mixed.map((e) => transform(e));
    }

    if (mixed === null || typeof mixed !== "object") {
      return mixed;
    }

    const transformedObject = {};
    Object.keys(mixed).forEach((key) => {
      const transformedKey = getTransformedKey(key);
      transformedObject[transformedKey] = transform(mixed[key]);
    });

    return transformedObject;
  };
  return transform(obj);
}

export function camelToUnderscore(obj) {
  return transformObjectKeys(obj, StringTransformer.camelToUnderscore);
}

export function underscoreToCamel(obj) {
  return transformObjectKeys(obj, StringTransformer.underscoreToCamel);
}

export function toArray(obj) {
  return Object.keys(obj).map((k) => obj[k]);
}
